// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"603":"ee877dd3","794":"b7ccc861"}[chunkId] + ".chunk.css";
};